import axios from 'axios';

const api = axios.create({
    baseURL: process.env.API_URL,
    timeout: 30000,
    withCredentials: true,
    headers: {
        'Content-Type': 'application/json'
    }
});

api.interceptors.response.use(
    response => response,
    error => {
        if (! error.response) {
            // looks like this can happen if the timeout is reached
            console.log('api.interceptors.response.use, error, no response..');
            throw error;
        }

        if (401 === error.response.status) {
            // whatever you want to do with the error
            // console.log('Axios ERROR!!', error);

            if (window.location.pathname !== '/login') {
                window.location = '/login';
            }

            throw error;
        }

        if (419 === error.response.status) {
            // CSRF token issue
            console.log('Invalid CSRF detected, retrying...');

            return api.get('/sanctum/csrf-cookie').then(() => {
                return api.request(error.config);
            })
        }

        throw error;
    }
);

export default api;